import ColumnLayout from '@cloudscape-design/components/column-layout';
import Container from '@cloudscape-design/components/container';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { MarketingContainer, SectionHeader } from '@vextura/shell';
import type { ReactNode } from 'react';
import { PROOF } from '../content.js';

/**
 * Proof — one real customer, three big numbers, one story line. Optional
 * testimonial (hidden when PROOF.testimonial is null so we never ship a
 * fabricated quote). Logo row is single-logo for v1 — never fake more.
 */
export function Proof(): ReactNode {
  return (
    <MarketingContainer paddingY="default">
      <SpaceBetween size="xl">
        <SectionHeader eyebrow="Proof" headline={PROOF.headline} />
        <ColumnLayout columns={3} variant="text-grid">
          {PROOF.stats.map((s) => (
            <Container key={s.value}>
              <div
                style={{
                  fontSize: 44,
                  fontWeight: 800,
                  letterSpacing: -1,
                  background: 'linear-gradient(90deg, #6366f1, #a855f7)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  lineHeight: 1,
                  marginBottom: 12,
                }}
              >
                {s.value}
              </div>
              <div style={{ color: '#64748b', lineHeight: 1.6 }}>{s.caption}</div>
            </Container>
          ))}
        </ColumnLayout>
        <Container>
          <div style={{ padding: '8px 8px', lineHeight: 1.7, color: '#334155', fontSize: 16 }}>
            {PROOF.story}
          </div>
        </Container>
        {PROOF.testimonial ? (
          <Container>
            <blockquote style={{ margin: 0, padding: 8 }}>
              <div style={{ fontSize: 20, lineHeight: 1.5, color: '#0f172a' }}>
                "{PROOF.testimonial.quote}"
              </div>
              <div style={{ marginTop: 12, color: '#64748b', fontSize: 14 }}>
                — {PROOF.testimonial.author}, {PROOF.testimonial.org}
              </div>
            </blockquote>
          </Container>
        ) : null}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 32,
            paddingTop: 8,
          }}
        >
          <span
            style={{
              fontSize: 12,
              letterSpacing: 1,
              textTransform: 'uppercase',
              color: '#94a3b8',
              fontWeight: 600,
            }}
          >
            Trusted by
          </span>
          {PROOF.logos.map((l) => (
            <a
              key={l.name}
              href={l.href ?? '#'}
              style={{
                fontSize: 18,
                fontWeight: 700,
                color: '#475569',
                textDecoration: 'none',
                letterSpacing: -0.3,
              }}
            >
              {l.name}
            </a>
          ))}
        </div>
      </SpaceBetween>
    </MarketingContainer>
  );
}
